/*
 * Dialog
 *
 * Creates a dialog popup out of any element you specify
 *
 * Depends:
 *    jQuery
 *    jquery.ih.widget.js
 *    jquery.ih.mask.js
 *
 *
 * Usage:
 *
 * $("#my_div").dialog();
 *
 *
 */
/*
    Dialog is a jquery ui widget class
*/
(function($) {

    $.widget( "ih.dialog", {
        options: {
            debug:              false,                              // enable debug log
            cssClass:           "ih-dialog",                        // the css class for the dialog container
            
            modal:              true,                               // page is masked to enforce modal context
            maskOptions:        {
                zIndex: 9000
            },
            clickMaskToClose:   false,                              // click on mask to close the dialog
            
            zIndex:             9001,                               // int (sets mask at this zindex and dialog at zindex + 1) or false
            openOnTop:          false,                              // ensures that newest dialog opens on top of other dialogs (of the same cssClass)
                                                                    // NOTE: this will override the zIndex option above as needed.
            closeX:             true,
            
            autoOpen:           true,                               // open dialog upon instantiation
            autoDestroy:        false,                              // auto-destroy on close
            autoDestroyDelay:   500,                                // delay (in ms) allows close animation to finish (or false)
            
            
            draggable: false,                                       // is the dialog draggable
            draggableOptions: {},
            
            // fn
            openAllowed:    function() { return true; },            // write your own function that returns a boolean
            
            // callbacks
            create:         function(e, obj) { return false; },
            open:           function(e, obj) { return false; },
            update:         function(e, obj) { return false; },
            close:          function(e, obj) { return false; },
            destroy:        function(e, obj) { return false; }
        },

        _create: function() {
            if ( this.options.debug ) console.log("create ih dialog!");

            // properties
            this.isOpen = false;

            // for now, just assume it is a single element and that it already exists in the DOM
            this.element.addClass( this.options.cssClass );
            
            if ( this.options.closeX ) {
                this.closeX = $("<div>&times;</div>").addClass(this.options.cssClass + "-close").appendTo( this.element );
                
                this._on( this.closeX, {
                    "click": function(e) {
                        e.preventDefault();
                        this.close();
                    }
                });
            }
            
            if ( this.options.title ) {
                this.title = $("<div>").addClass(this.options.cssClass + "-title").appendTo( this.element );
                this.title.html( this.options.title );
            }
            
            this.body = $("<div>").addClass(this.options.cssClass + "-body").appendTo( this.element );
            
            if ( this.options.draggable ) {
                this.element.draggable(this.options.draggableOptions);
            }
            
            this._trigger("create", null, this);

            if ( this.options.autoOpen ) {
                this.open();
            }
        },


        _destroy: function() {
            if ( this.options.debug ) console.log("destroy ih dialog");
            
            if ( this.options.draggable ) {
                this.element.draggable("destroy");
            }
            
            // TODO: update css to use the dash version, then remove the underscore version
            this.element.removeClass( this.options.cssClass + "_open " + this.options.cssClass + "-open" );
            
            if ( this.options.zIndex || this.options.openOnTop ) {
                this.element.css("zIndex", "");
            }
            
            if ( this.options.modal && this.element.is(":data('ih-mask')") ) {
                this.element.mask("close");
                $("body").css({ 'overflow': '' });
            }
            
            if ( this.options.autoDestroy ) {
                this.element.remove();
            }
            
            // callback
            this._trigger("destroy", null, this);
        },


        
        
        
        open: function( event ) {

            // bail out if not allowed to open or if already open
            if ( ! this.options.openAllowed() ) return false;
            if ( this.isOpen ) return false;

            if ( this.options.debug ) console.log("open ih dialog");


            // check if we need to open on top of an another already open dialog
            var zIndexToUse = false;

            if ( this.options.openOnTop ) {
                var open_dialogs = $("." + this.options.cssClass + ":visible").not(this.element);
                if ( open_dialogs.length ) {
                    if ( this.options.debug ) console.log("There is at least one other dialog open: " + open_dialogs.length);

                    // grab an array of their zindexes
                    var zIndexes = $.map(open_dialogs, function (elem) {
                        return parseInt( $(elem).css('zIndex') );
                    });
                    if ( this.options.debug ) console.log("zindexes array", zIndexes);

                    // grab highest value and iterate up by one
                    var zIndexToUse = Math.max.apply(Math, zIndexes) + 1;
                    if ( this.options.debug ) console.log("highest", zIndexToUse);

                    // Use specified zIndex from options if it is high enough
                    if ( this.options.zIndex && this.options.zIndex >= zIndexToUse ) {
                        zIndexToUse = this.options.zIndex;
                    }
                }
                else {
                    if ( this.options.debug ) console.log("All Clear! No other open dialogs.");
                }
            }

            // TODO: update css to use the dash version, then remove the underscore version
            this.element.addClass( this.options.cssClass + "_open " + this.options.cssClass + "-open" );

            this.isOpen = true;

            // attach a zIndex if one is specified
            if ( this.options.zIndex || zIndexToUse ) {

                if ( this.options.debug ) console.log("inlining a zIndex style!!");

                // dialog gets set at zIndex + 1, mask is set at zIndex
                var z = ( zIndexToUse ) ? zIndexToUse + 1 : parseInt( this.options.zIndex ) + 1;
                this.element.css("zIndex", z);
            }

            if ( this.options.modal ) {
                var mask = this.element.mask({
                    cssClass: this.options.cssMaskClass,
                    zIndex: ( zIndexToUse ) ? zIndexToUse : this.options.zIndex
                });

//                console.log("mask", mask);

                // prevent body from scrolling
                $("body").css({ 'overflow': 'hidden' });
            }

            // callback
            this._trigger("open", event, this);
        },


        close: function( event ) {
            var that = this;

            // bail out if already closed
            if ( ! this.isOpen ) return false;

            if ( this.options.debug ) console.log("close ih dialog");
            
            // TODO: update css to use the dash version, then remove the underscore version
            this.element.removeClass( this.options.cssClass + "_open " + this.options.cssClass + "-open" );

            if ( this.options.zIndex || this.options.openOnTop ) {
                this.element.css("zIndex", "");
            }

            if ( this.options.modal && this.element.is(":data('ih-mask')") ) {
                this.element.mask("close");
                $("body").css({ 'overflow': '' });
            }
            this.isOpen = false;

            // callback
            this._trigger("close", event, this);

            if ( this.options.autoDestroy ) {
                if ( this.options.autoDestroyDelay ) {
                    setTimeout( function() {
                        $this.destroy();
                    }, that.options.autoDestroyDelay);
                }
                else {
                    that.destroy();
                }
            }
        },


        update: function( event, content ) {

            if ( this.options.debug ) console.log("update ih dialog");
            this.element.html( content );

            // callback
            this._trigger("update", event, this);
        }
    });

})( jQuery );